import { get, post } from './api'

const FINANCE_PREFIX = '/blade-portal/finance'

export const financeService = {
  /**
   * 获取客户账户信息
   */
  async getAccountInfo() {
    const response = await get(`${FINANCE_PREFIX}/account`)
    return response
  },

  /**
   * 获取账户交易记录
   */
  async getTransactions(params = {}) {
    const response = await get(`${FINANCE_PREFIX}/transactions`, {
      current: params.current || 1,
      size: params.size || 50,
      transactionType: params.transactionType,
      keyword: params.keyword,
    })
    return response
  },

  /**
   * 交易查询（带筛选）
   */
  async queryTransactions(params = {}) {
    return this.getTransactions(params)
  },

  /**
   * 获取付款记录
   */
  async getPaymentRecords(params = {}) {
    const response = await get(`${FINANCE_PREFIX}/payments`, {
      current: params.current || 1,
      size: params.size || 20,
      keyword: params.keyword,
    })
    return response
  },

  /**
   * 获取对账列表
   */
  async getReconciliationList(params = {}) {
    const response = await get(`${FINANCE_PREFIX}/reconciliation/list`, {
      current: params.current || 1,
      size: params.size || 20,
      reconcileStatus: params.reconcileStatus,
    })
    return response
  },

  /**
   * 标记已对账
   */
  async markReconciled(transactionId) {
    const response = await post(`${FINANCE_PREFIX}/reconciliation/mark`, { transactionId })
    return response
  },

  /**
   * 提交对账异常
   */
  async submitReconciliationException(transactionId, issueDescription) {
    const response = await post(`${FINANCE_PREFIX}/reconciliation/exception`, {
      transactionId,
      issueDescription,
    })
    return response
  },

  /**
   * 申请充值
   */
  async requestRecharge(amount, remark, paymentMethod) {
    const response = await post(`${FINANCE_PREFIX}/recharge`, { amount, remark, paymentMethod })
    return response
  },

  /**
   * 获取汇率
   */
  async getExchangeRates() {
    const response = await get(`${FINANCE_PREFIX}/exchange-rates`)
    return response
  },

  /**
   * 汇率测算
   */
  async calculateExchange(data) {
    const response = await post(`${FINANCE_PREFIX}/exchange-calculate`, {
      sourceCurrency: data.sourceCurrency,
      targetCurrency: data.targetCurrency,
      amount: data.amount,
    })
    return response
  },

  /**
   * 提交融资申请
   */
  async submitFinancingApplication(data) {
    const response = await post(`${FINANCE_PREFIX}/financing/apply`, {
      applicationType: data.applicationType,
      requestedAmount: data.requestedAmount,
      remark: data.remark,
    })
    return response
  },

  /**
   * 获取融资申请列表
   */
  async getFinancingApplications(params = {}) {
    const response = await get(`${FINANCE_PREFIX}/financing/list`, {
      current: params.current || 1,
      size: params.size || 20,
      status: params.status,
    })
    return response
  },

  /**
   * 提交购汇申请
   */
  async submitForexApplication(data) {
    const response = await post(`${FINANCE_PREFIX}/forex/apply`, {
      sourceCurrency: data.sourceCurrency || 'CNY',
      targetCurrency: data.targetCurrency,
      amount: data.amount,
      remark: data.remark,
    })
    return response
  },

  /**
   * 获取收汇申请列表
   */
  async getForexApplications(params = {}) {
    const response = await get(`${FINANCE_PREFIX}/forex/list`, {
      current: params.current || 1,
      size: params.size || 20,
      status: params.status,
    })
    return response
  },

}

export default financeService
